export default __webpack_public_path__ + "static/media/slide_01.281e8210.gif";